<template>
    <div class="px-[18px] py-[9px] border-b border-[#E9EEF2] flex items-center justify-between">
        <div class="flex items-center gap-4">
            <ResumeIconBig/>
            <DocumentName
                :resumeTitle="resumeTitle"
            />
            <DocumentAccessRights/>
        </div>
    
        <div class="flex items-center gap-2">
            <button
                class="
                    text-[14px] leading-[18px] relative flex justify-center items-center
                    font-[Roboto] border border-won-green rounded px-3 py-1.5 text-won-green
                    disabled:border-won-gray disabled:opacity-40
                "
                :disabled="duplicateLoading"
                @click="duplicateResumeHandler"
            >
	            <span
		            class="flex items-center gap-2"
	            >
		            <span v-if="duplicateLoading">
	                    <LoadingIcon
		                    size="size-[18px]"
	                    />
	                </span>

                    <DocumentDuplicateIcon
	                    v-else
	                    class="size-[18px]"
                    />

                    <span>Duplicate</span>
                </span>
            </button>

	        <CopyShareLinkBtn
		        v-if="isAuthenticated()"
		        :disabled="false"
		        buttonSize="size-[18px]"
	        />

            <ShareResumeBtn
	            v-else
	            :emitClickEvent="true"
				@click-handler="authPopupStore.setShowAuthPopup"
            />

	        <button
		        v-if="isAuthenticated()"
		        @click="downloadDocumentHandler"
		        :disabled="downloadLoading"
		        class="flex items-center justify-center cursor-pointer rounded select-none h-8 w-[138px] py-2.5 px-2 bg-[#b6dbc4]"
	        >
		        <span class="won-blue text-sm font-medium">Download</span>
	        </button>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useBuilder } from "../../store/builder.store";
import { extractContent } from "../../utils/helpers";
import { setAuthState } from "../../composables/auth";
import { downloadPdf } from "../../api/download";

import { useAuthPopupStore } from "../../store/auth-popup.store";
import { useResumesStore } from "../../store/resumes.store";

import ShareResumeBtn from "../resume-tool/share-resume-btn.vue";
import DocumentName from "../resume-tool/document-name.vue"
import DocumentAccessRights from "../resume-tool/document-access-rights.vue";
import ResumeIconBig from "../../icons/resume-icon-big.vue";
import CopyShareLinkBtn from "../resume-tool/copy-share-link-btn.vue";

import { DocumentDuplicateIcon } from "@heroicons/vue/24/outline"
import LoadingIcon from "../../icons/loading-icon.vue";

const { isAuthenticated, getUser } = setAuthState();

const resumesStore = useResumesStore();
const builderStore = useBuilder();
const authPopupStore = useAuthPopupStore();
const { data } = storeToRefs(builderStore);
const { duplicateLoading } = storeToRefs(resumesStore);

const downloadLoading = ref(false);

const resumeTitle = computed(() => {
    return extractContent(data.value.title);
})

const downloadDocumentHandler = async () => {
	downloadLoading.value = true;

	try {
		const parsedURL = new URL(window.location.href)
		const host = parsedURL.hostname === 'localhost' ? 'http://localhost:8000' : parsedURL.origin
		const url = `${host}/resume/preview/${data.value.uuid}`

		await downloadPdf({url, user: {name: getUser()?.name, email: getUser()?.email}}, extractContent(data.value.title));
	}catch (error) {
		notificationsStore.notify('Failed to download the document!', 'error')
	}finally {
		downloadLoading.value = false;
	}
}

const duplicateResumeHandler = async () => {
	if(isAuthenticated()){
		const resumeId = data.value.uuid;
		await resumesStore.duplicateResume(resumeId);
	}else{
		authPopupStore.setShowAuthPopup();
	}
}
</script>
